var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsIconInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1624_69142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 0H9.12485C8.75825 0 8.24587 0.212381 7.98685 0.471207L0.389089 8.06892C-0.129696 8.58712 -0.129696 9.43673 0.389089 9.9543L6.04624 15.6113C6.56385 16.1295 7.41263 16.1295 7.93103 15.6107L15.5288 8.01412C15.7876 7.75533 16 7.24213 16 6.87632V1.33339C16 0.600191 15.3998 0 14.6666 0ZM11.9998 5.33336C11.2634 5.33336 10.6664 4.73575 10.6664 3.99997C10.6664 3.26298 11.2634 2.66658 11.9998 2.66658C12.7362 2.66658 13.3334 3.26298 13.3334 3.99997C13.3334 4.73575 12.7362 5.33336 11.9998 5.33336Z",
    fill: "current",
    fillOpacity: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_69142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsIconInput);
export default __webpack_public_path__ + "static/media/TagsIconInput.7128626edec3f0a1543ae2ef74012679.svg";
export { ForwardRef as ReactComponent };